import React from "react";
import Table from "../../Common/Table";
import TableFields from "../../../constants/FleetCoachDriverMapping/TableField.json";
import { useHistory } from "react-router-dom";
import { Pill } from "../../../constants/assets/containers";

const IssuedList = (props) => {
  const { list } = props;
  const history = useHistory();

  const handleDriverIdClick = (fe_id) => {
    history.push(`delivery-drivers/${fe_id}/details`);
  };

  const handleFleetCoachIdClick = (fleet_coach_id) => {
    history.push(`fleet-coach/${fleet_coach_id}`);
  };

  const getFieldValue = (item, key) => {
    switch (key) {
      case "mapping_status":
        return (
          <Pill isFalse={!item[key]}>
            {item[key] == true ? "MAPPED" : "UNMAPPED"}
          </Pill>
        );
      case "fe_id":
        return (
          <span
            onClick={() => handleDriverIdClick(item[key])}
            className="edit-options"
          >
            {item[key]}
          </span>
        );
      case "fc_id":
        return (
          <span
            onClick={() => handleFleetCoachIdClick(item["fleet_coach_id"])}
            className="edit-options"
          >
            {item[key]}
          </span>
        );
      default:
        return item[key] || item["asset"][key];
    }
  };

  return (
    <Table list={list} getFieldValue={getFieldValue} fields={TableFields} />
  );
};

export default IssuedList;
